import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo } from 'react';
import styleUtils from '../../styles/styleUtils';
import { Fade } from '../Fade/index';
import { Icon } from '../Icon/index';
import { alignments, variations, spinnerColors, } from './constants';
const spinnerContainerCss = css `
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.62);
  z-index: 100;
  ${styleUtils.flexCenter}
`;
const outerCircleDiameter = styleUtils.rem(56);
const outerCircleCss = css `
  width: ${outerCircleDiameter};
  height: ${outerCircleDiameter};
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 0 ${styleUtils.rem(5)} 0 rgba(0, 0, 0, 0.75);
  ${styleUtils.flexCenter}
`;
const alignTopCss = css `
  position: absolute;
  top: ${styleUtils.rem(75)};
`;
const defaultProps = {
    alignment: alignments.center,
    loading: false,
    variation: variations.overlay,
};
const LoadingSpinner = ({ alignment = defaultProps.alignment, loading = defaultProps.loading, variation = defaultProps.variation, }) => (_jsx(Fade, Object.assign({ in: loading, unmountOnExit: true }, { children: _jsx("div", Object.assign({ css: spinnerContainerCss }, { children: _jsx("div", Object.assign({ css: css `
          ${variation === variations.overlay && outerCircleCss}
          ${alignment === alignments.top && alignTopCss}
          color: ${spinnerColors[variation]};
        ` }, { children: _jsx(Icon, { size: "large", type: "load-spinner" }) })) })) })));
const MemoizedLoadingSpinner = memo(LoadingSpinner);
export { MemoizedLoadingSpinner as LoadingSpinner };
// MC-1068 Temporary hack for Storybook.
export default LoadingSpinner;
